module.exports = "/images/jr.png";